export const PROMO_CODES_LOADING = "promoCodes/LOADING";
export const PROMO_CODES_ERROR = "promoCodes/ERROR";

export const PROMO_CODES_LIST = "promoCodes/LIST";
export const PROMO_CODES_SEARCH = "promoCodes/SEARCH";
export const PROMO_CODES_FILTERS = "promoCodes/FILTERS";
export const PROMO_CODES_CREATE = "promoCodes/CREATE";
export const PROMO_CODES_UPDATE = "promoCodes/UPDATE";
export const PROMO_CODES_DELETE = "promoCodes/DELETE";
export const PROMO_CODES_STATUSES = "promoCodes/STATUSES";



// WEBPACK FOOTER //
// ./src/actions/promo-codes/constants.js